import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Http } from '@angular/http';
import { TranslateService } from "@ngx-translate/core";
import { sortBy } from 'lodash';
import * as moment from 'moment';
import { NgProgress } from "ngx-progressbar";
import { Observable } from 'rxjs/Observable';
import { ApiUrlConstants } from "../../common/constants/api.constants";
import { AccessLevel } from "../../common/enums/access-level.enum";
import { Permission } from "../../common/enums/permission.enum";
import { CacheKey } from "../../shared/constants/cachekey.constants";
import { Country } from "../../shared/interface/country.interface";
import { UserInfo } from "../../shared/interface/user-info.interface";
import { CacheService } from "../../shared/services/cache.service";
import { CommonService } from "../../shared/services/common.service";
import { MessageService } from "../../shared/services/message.service";
import { Utils } from "../../shared/Utils/utils";
import { CommonMessage } from "../common/common-messages";
import { MemberType } from "../common/constants";
import { OperatingCountryEnums } from "../enums/countries.enums";
import { NotificationType } from '../enums/notification-types.enum';
import { Status } from "../enums/ticket-status.enum";
import { Priority, SourceType, SubtypesEnums, TicketType } from '../enums/ticket-type.enum';
import { BusinessEntity } from "../interface/businessentity";
import { CopyToSearchResponse, CopyToUserResponse } from '../interface/ticketingsystem/copy-to-search-response.interface';
import { CopyToUser } from '../interface/ticketingsystem/copy-to-users.interface';
import { DistributorInfo } from "../interface/ticketingsystem/distributor-info";
import { CreateTicketRequest } from "../interface/ticketingsystem/ticket-create";
import { DeleteModal } from "../models/delete-modal";
import { TicketTabInfo } from "../models/tickets-tab.model";
import { CustomerService } from "../services/customer.service";
import { DepartmentService } from "../services/department.service";
import { OrderService } from "../services/order.service";
import { DateConstants } from '../constants/date.constants';
import { DisplayNameFormatPipe } from "../../common/pipes/display-name-format.pipe";

@Component({
    selector: "create-work-ticket",
    templateUrl: "../templates/template1/views/work-ticket-create.component.html",
    styleUrls: [
        "../templates/template1/themes/default/css/ticket.less"
    ],
    providers: [DisplayNameFormatPipe]
})
export class CreateWorkTicket implements OnInit {

    @Input() distributorInfo: DistributorInfo;
    @Input() tabIndex: number;
    @Input() countryCode: string;
    FBOManageTicketPermissions: any[] = [
        Permission.MANAGE_TICKETS_CREATE,
        Permission.MANAGE_DEPARTMENT_TICKETS_ASSIGN,
        Permission.MANAGE_TICKETS_ADD_NOTE_ATTACHMENT,
        Permission.MANAGE_TICKETS_VIEW
    ];
    ManageDepartmentPermissions: any[] = [
        Permission.MANAGE_DEPARTMENT_TICKETS_CLOSE,
        Permission.MANAGE_DEPARTMENT_TICKETS_RE_OPEN,
        Permission.MANAGE_DEPARTMENT_TICKETS_EDIT,
        Permission.MANAGE_DEPARTMENT_TICKETS_SELF_ASSIGN,
        Permission.MANAGE_DEPARTMENT_TICKETS_REASSIGN,
        Permission.MANAGE_DEPARTMENT_TICKETS_ASSIGN
    ];
    ticketCreateForm: FormGroup;
    isSubmitted: boolean = false;
    userInfo: UserInfo;
    isTicketCreate: any;
    isTicketAssign: any;
    isTicketAddorAttachment: any;
    isTicketView: any;
    orderTypeId: number;
    productTypeId: number;
    businessEntities: BusinessEntity[] = [];
    countries: any;
    uploader: any;
    ticketTypes: any[];
    ticketResponse: any;
    uploadResponse: any = [];
    sourceTypes: any[];
    sourceTypesEnum: any = SourceType;
    locationTypes: any;
    ticketPriorities: any[];
    ticketStatus: any[];
    subTypes: any[];
    departments: any[];
    users: any[];
    isTicketAssignPermission: boolean = false;
    attachmentsLength: number;
    attachmentWarning: DeleteModal;
    clearFormAlert: DeleteModal;
    enableLocationType: boolean = false;
    disableCreate: boolean;
    validWebOrderNumber: boolean;
    elementoffsetValue: number;
    inValidOrderNumber: boolean;
    showDatePicker = false;
    operatingCountryId: number;
    customerServiceAccessLevelId: number = AccessLevel.Customer_Service;
    phoneNumberFormat: string;
    countryPhoneFormat: string;
    allCountries: any;
    IsoCodeThree: string;
    subjectMaxLength: any = { maxLength: 500 };
    momentConstructor: (value?: any) => moment.Moment = (<any>moment).default || moment;
    public splitPattern = new RegExp('[\;]');

    constructor(private _translatePipe: TranslateService,
        private _commonService: CommonService, private _customerservice: CustomerService,
        private messageService: MessageService, private ngProgress: NgProgress,
        private _formbuilder: FormBuilder, private _cacheService: CacheService,
        private departmentService: DepartmentService,
        private _orderservice: OrderService,
        private _displayNamePipe: DisplayNameFormatPipe,
        private _http: Http) {
    }

    ngOnInit(): void {
        if (this.distributorInfo && this.distributorInfo.contactNumber) {
            this.distributorInfo.contactNumber = this.distributorInfo.contactNumber.replace(/\D/g, '');
        }
        this.buildForm();
        this.getSourceTypes();
        this.getTicketPriorities();
        this.getTicketStatus();
        this.getLocationTypes();
        this.userInfo = this._cacheService.get(CacheKey.UserInfo);
        this._commonService.getUserInformation(this.userInfo.userName).subscribe(data => {
            if (data) {
                this._cacheService.set(CacheKey.UserInfo, data);
                this.userInfo = data;
                this.isTicketCreate = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.FBOManageTicketPermissions[0] + "]"), AccessLevel.Customer_Service);
                this.isTicketAssign = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.FBOManageTicketPermissions[1] + "]"), AccessLevel.Customer_Service);
                this.isTicketAddorAttachment = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.FBOManageTicketPermissions[2] + "]"), AccessLevel.Customer_Service);
                this.isTicketView = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.FBOManageTicketPermissions[3] + "]"), AccessLevel.Customer_Service);
                this.getBusinessEntities();
            }
        });
        this.attachmentWarning = new DeleteModal(this.noAction.bind(this),
            this.noAction.bind(this), this.noAction.bind(this));
        this.clearFormAlert = new DeleteModal(this.clearForm.bind(this),
            this.noAction.bind(this), this.noAction.bind(this));
    }
    /**
      * Build form
      */
    buildForm() {
        this.ticketCreateForm = this._formbuilder.group(
            {
                operatingCountry: ['', Validators.required],
                country: [''],
                department: ['', Validators.required],
                source: [SourceType.Phone, Validators.required],
                callerName: [this.distributorInfo ? this._displayNamePipe.transform(this.distributorInfo) : '', Validators.required],
                ticketType: ['', Validators.required],
                assignTo: [''],
                sourceIdentifierValue: [this.distributorInfo ? this.distributorInfo.contactNumber : '',
                [Validators.required, Utils.PhoneNumValidationRule, Utils.PhoneNumLengthValidationRule]],
                priority: ['', Validators.required],
                subType: ['', Validators.required],
                subject: ['', [Validators.required, Validators.maxLength(this.subjectMaxLength.maxLength)]],
                description: ['', Validators.required],
                dueDate: [{ value: '', disabled: true }],
                orderId: [''],
                locationType: [''],
                filePath: [new Array<string>()],
                status: [Status.New, Validators.required],
                copyTo: [[]]
            });
    }

    getBusinessEntities() {
        this._customerservice.getAllBusinessEntities().subscribe(response => {
            if (response) {
                this.businessEntities = response;
                this.getAllowedCountries();
            }
        });
    }
    getAllowedCountries() {
        let countryIds: any = [];
        if (!this.userInfo.hasSystemRole) {
            if (this.userInfo.allowedOperatingCountries) {
                countryIds = this.userInfo.allowedOperatingCountries.split(",");
                if (this.userInfo.privileges.departments) {
                    countryIds.push.apply(countryIds, this.userInfo.privileges.departments.map(function (a) { return a.allowedOperatingCountries; }));
                }
                countryIds = countryIds ? countryIds : [];
                if (countryIds.length > 0) {
                    var ids = countryIds;
                    this.countries = this.businessEntities.filter(function (item) {
                        return ids.indexOf(item.id + "") != -1;
                    });
                }
            }
            else {
                this.countries = this.businessEntities;
            }
        }
        else {
            this.countries = this.businessEntities;
        }
        this.countries.sort(function (item1, item2) {
            var country1 = item1.name.toLowerCase(), country2 = item2.name.toLowerCase()
            if (country1 < country2) //sort string ascending
                return -1
            if (country1 > country2)
                return 1
            return 0
        });
        let usaInfo = this.countries.find((country: any) => country.id === OperatingCountryEnums.USA);
        if (usaInfo) {
            this.countries.splice(this.countries.indexOf(usaInfo), 1);
            this.countries.splice(0, 0, usaInfo);
        }
        this.loadDefaultOperatingCountry();
    }
    loadDefaultOperatingCountry(): void {
        if (this.countries && this.countries.length > 0) {
            const orderCreatedForCountry = this.countries.find((country: any) => country.value === this.countryCode);
            const defaultCountry: Country = orderCreatedForCountry ? orderCreatedForCountry : this.countries[0];
            this.ticketCreateForm.controls['operatingCountry'].setValue(defaultCountry.id);
            this.count = 0;
            this.attachmentsLength = 0;
            this.operatingCountryChange(defaultCountry.id);
            this.operatingCountryId = defaultCountry.id;
            this.uploader = this._customerservice.getFileUploader();
            this.uploader.onErrorItem = () => this.onErrorItem();
            this.uploader.onSuccessItem = (item: any, response: any, status: any, headers: any) => this.onSuccessItem(response);
            this.getTicketTypesAndSubTypes();
        }
    }
    getTicketTypesAndSubTypes() {
        this.ticketTypes = [];
        let operatingCountry = this.ticketCreateForm.controls['operatingCountry'].value;
        if (operatingCountry) {
            this.departmentService.getTicketTypesAndSubTypes(operatingCountry).subscribe(response => {
                if (response) {
                    this.ticketTypes = response;
                    this.ticketTypes.forEach(type => {
                        if (type.value) {
                            type.sortValue = type.value.toLowerCase();
                        }
                    });
                    const orderType = response.find((type: any) => type.value === TicketType.Order);
                    if (orderType) {
                        this.orderTypeId = orderType.id;
                    }
                    const productType = response.find((type: any) => type.value === TicketType.Product);
                    if (productType) {
                        this.productTypeId = productType.id;
                    }
                }
            });
        }
    }


    /**
 * failed to upload file
 * @param item 
 * @param response 
 * @param status 
 * @param headers 
 */
    onErrorItem(): any {
        this.ngProgress.done();
        this._commonService.createNotification("", "Failed to upload document. Please try after sometime ", NotificationType.ERROR);
    }
    /**
         * On Successful upload of file
         * @param item 
         * @param response 
         * @param status 
         * @param headers 
         */
    count: number = 0;
    onSuccessItem(response: string): any {
        if (response) {
            let res = JSON.parse(response);

            let fileDetails = {
                "userId": this.userInfo.userId,
                "fileName": this.uploader.queue[this.count].file.name.substr(0, 95),
                "url": res.url,
                "eTag": res.eTag,
                "key": res.key
            }
            this.uploadResponse.push(fileDetails);
            this.count++;
            if (this.uploader.queue.length === this.count) {
                //Save Attachment
                this.saveAttachments(this.uploadResponse);
            }

        }
        else {
            this._commonService.createNotification("", "File Not uploaded", NotificationType.ERROR);
        }
        this.ngProgress.done();
    }
    saveAttachments(attachments: any) {
        this._customerservice.saveAttachments(attachments, this.ticketResponse.id).subscribe(response => {
            if (response) {
                let res = response;
                let addedNotification: any = this._translatePipe.get("Ticket " + this.ticketResponse.ticketNumber + " has been Created successfully");
                this._commonService.createNotification("", addedNotification.value, NotificationType.SUCCESS);
                this.closeTab();
            }
        });
    }

    getSourceTypes() {
        this._customerservice.getSourceTypes().subscribe((response) => {
            if (response) {
                this.sourceTypes = response;
            }
        });
    }

    clearForm() {
        this.isSubmitted = false;
        this.ticketCreateForm.controls['source'].setValue(SourceType.Phone);
        this.ticketCreateForm.controls['sourceIdentifierValue'].setValue(this.distributorInfo.contactNumber);
        this.ticketCreateForm.controls['sourceIdentifierValue'].setValidators(null);
        this.ticketCreateForm.controls['callerName'].setValue(this.distributorInfo.name);
        this.ticketCreateForm.controls['dueDate'].setValue('');
        this.showDatePicker = false;
        this.ticketCreateForm.controls['dueDate'].disable();
        this.ticketCreateForm.controls['priority'].setValue(Priority.Medium);
        this.ticketCreateForm.controls['locationType'].setValue('');
        this.ticketCreateForm.controls['status'].setValue(Status.New);
        this.ticketCreateForm.controls['description'].setValue('');
        this.ticketCreateForm.controls['subject'].setValue('');
        this.ticketCreateForm.controls['copyTo'].setValue([]);
        this.enableLocationType = false;
        this.loadDefaultOperatingCountry();
    }
    getTicketPriorities() {
        this._customerservice.getTicketPriorities().subscribe((response) => {
            if (response) {
                this.ticketPriorities = response;
                this.setDefaultPriority();
            }
        });
    }

    getTicketStatus() {
        this._customerservice.getTicketStatus().subscribe((response) => {
            if (response) {
                this.ticketStatus = response;
                this.ticketStatus = sortBy(this.ticketStatus, 'value');
            }
        });
    }

    // get location types and display when product is selected
    getLocationTypes() {
        this._customerservice.getLocationTypes().subscribe(response => {
            if (response) {
                this.locationTypes = response;
            }
        });
    }
    /*
    set medium as default priority..
    */
    setDefaultPriority() {
        if (this.ticketPriorities && this.ticketPriorities.length > 0) {
            this.ticketCreateForm.controls['priority'].setValue(Priority.Medium);
        }
    }
    operatingCountryChange(id: any, isCountryChange?: Boolean): void {
        if (id) {
            if (this.countries && this.countries.length) {
                const selectedCountry = this.countries.find((country: Country) => country.id === +id);
                if (selectedCountry) {
                    this.getAllCountries(selectedCountry.value);
                    this.phoneNumberFormat = this._commonService.getPhoneNumberFormatByCountryCode(selectedCountry.value);
                    this.countryPhoneFormat = this.phoneNumberFormat;
                }
            }
            this.ticketCreateForm.controls['ticketType'].setValue('');
            this.ticketCreateForm.controls['subType'].setValue('');
            this.ticketCreateForm.controls['department'].setValue('');
            this.ticketCreateForm.controls['assignTo'].setValue('');
            this.uploader = this._customerservice.getFileUploader();
            this.operatingCountryId = +id;
            this.uploader.onErrorItem = () => this.onErrorItem();
            this.uploader.onSuccessItem = (item: any, response: any, status: any, headers: any) => this.onSuccessItem(response);
            this.getTicketTypesAndSubTypes();
            this.getDeparments();
            if (this.ticketCreateForm.controls['orderId'] && this.ticketCreateForm.controls['orderId'].value && isCountryChange) {
                this.getRecentOrderInformation();
            }
        }
    }
    getSubTypes(event: any) {
        let ticketTypeId = +event;
        this.subTypes = [];
        this.enableLocationType = false;
        this.validWebOrderNumber = true;
        this.disableCreate = false;
        this.ticketCreateForm.controls['orderId'].setValue('');
        this.ticketCreateForm.controls['orderId'].setValidators([]);
        this.ticketCreateForm.controls['locationType'].setValidators([]);
        if (ticketTypeId) {
            let types: any[] = JSON.parse(JSON.stringify(this.ticketTypes))
            this.ticketCreateForm.controls['subType'].setValue('');
            this.subTypes = types.find(item => item.id === ticketTypeId).subTypes;
            if (ticketTypeId == this.orderTypeId) {
                this.subTypes = this.subTypes.filter((item) => { return (item.id !== SubtypesEnums.Dispute && item.id !== SubtypesEnums.Cancel); })
                this.ticketCreateForm.controls['locationType'].setValue('');
            }
            else if (ticketTypeId == this.productTypeId) {
                this.ticketCreateForm.controls['locationType'].setValidators([Validators.required]);
                this.enableLocationType = true;
                this.ticketCreateForm.controls['orderId'].setValue('');
            }
            if (ticketTypeId != this.productTypeId) {
                this.ticketCreateForm.controls['locationType'].setValue('');
            }
            if (ticketTypeId != this.orderTypeId) {
                this.ticketCreateForm.controls['orderId'].setValue('');
            }
        }
        this.ticketCreateForm.controls['orderId'].updateValueAndValidity();
        this.ticketCreateForm.controls['locationType'].updateValueAndValidity();

    }

    /**
     * get Departments By operatng ountry id
     */
    getDeparments() {
        if (this.ticketCreateForm.controls["operatingCountry"].value) {
            this._customerservice.getAllDepartmentsByOperatingCountryId(+this.ticketCreateForm.controls["operatingCountry"].value).subscribe(response => {
                if (response) {
                    this.departments = response;
                    this.departments.sort(function (item1, item2) {
                        var dept1 = item1.value.toLowerCase(), dept2 = item2.value.toLowerCase()
                        if (dept1 < dept2) //sort string ascending
                            return -1
                        if (dept1 > dept2)
                            return 1
                        return 0
                    });
                    this.ticketCreateForm.controls['department'].setValue('');
                    if (this.departments && this.departments.length === 1) {
                        this.ticketCreateForm.controls['department'].setValue(this.departments[0].id);
                        this.getAssignedUsersByDepartments(this.departments[0].id);
                    }
                } else {
                    this.departments = [];
                    this.ticketCreateForm.controls['department'].setValue('');
                    this.getAssignedUsersByDepartments("");
                }
            });
        } else {
            this.departments = [];
            this.users = [];
        }
    }
    getAssignedUsersByDepartments(event: any) {
        let departmentId = +event;
        this.ticketCreateForm.controls['assignTo'].setValue('');
        // as per JIRA #PS2021-1080
        // if (!this.userInfo.hasSystemRole) {
        //     this.isTicketAssignPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.ManageDepartmentPermissions[5] + "]"), AccessLevel.Department, departmentId);
        // } else {
        this.isTicketAssignPermission = true;
        // }
        // if (!this.isTicketAssignPermission) {
        //     this.ticketCreateForm.controls["assignTo"].disable();
        //     this.users = [];
        //     this.ticketCreateForm.controls['assignTo'].setValue('');
        //     this.ticketCreateForm.controls["dueDate"].setValue('');
        //     this.showDatePicker = false;
        //     this.ticketCreateForm.controls["dueDate"].disable();
        // } else {
        this.ticketCreateForm.controls["assignTo"].enable();
        if (departmentId) {
            this._customerservice.getAssignedUsersByDepartments(departmentId).subscribe(response => {
                if (response) {
                    this.users = response;
                    if (this.users && this.users.length > 0) {
                        this.users = this.users.sort(function (a, b) {
                            return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
                        });
                    }
                    this.assignToChange();
                } else {
                    this.users = [];
                    this.ticketCreateForm.controls['assignTo'].setValue('');
                }
            });
        }
        // }
        if (departmentId === 0) {
            this.ticketCreateForm.controls["assignTo"].enable();
            this.users = [];
            this.ticketCreateForm.controls['assignTo'].setValue('');
        }
    }
    createTicket() {
        this.isSubmitted = true;
        this.disableCreate = true;
        const invalidFields: any = document.querySelectorAll('#Create-Ticket-js .ng-invalid');
        window.scrollTo(this.elementoffsetValue, 0)

        if (invalidFields[0]) {
            invalidFields[0].focus();
            this.disableCreate = false;
        }
        if (this.ticketCreateForm.valid && (this.validWebOrderNumber || this.ticketCreateForm.controls['orderId'].value.length == 0)) {
            let ticket = new CreateTicketRequest();
            let createTicketValues: any = this.ticketCreateForm.getRawValue();
            ticket.sourceId = createTicketValues.source;
            ticket.callerName = createTicketValues.callerName;
            ticket.operatingCountryId = createTicketValues.operatingCountry;
            ticket.typeId = createTicketValues.ticketType;
            ticket.subTypeId = createTicketValues.subType;
            ticket.description = createTicketValues.description;
            ticket.departmentId = +createTicketValues.department;
            ticket.priorityId = createTicketValues.priority;
            ticket.dueDate = createTicketValues.dueDate ? Utils.convertToSpecificDateFormat(createTicketValues.dueDate, DateConstants.DOBFormat) : null;
            ticket.subject = createTicketValues.subject;
            ticket.assignedToId = createTicketValues.assignTo;
            ticket.memberId = this.distributorInfo.distributorId ? this.distributorInfo.distributorId : "";
            ticket.distributorName = this.distributorInfo.name;
            ticket.agentEmail = this.userInfo.email;
            ticket.agentName = this.userInfo.firstName + ' ' + this.userInfo.lastName;
            ticket.ticketLink = window.location.href;
            ticket.countryId = this._commonService.getCountry(this.IsoCodeThree, true);
            if (this.users && ticket.assignedToId) {
                const assignedToUser = this.users.find(item => item.id === +ticket.assignedToId);
                if (assignedToUser) {
                    ticket.assignedToEmail = assignedToUser.email;
                }
            }
            if (this.distributorInfo.memberType === MemberType.RETAIL || this.distributorInfo.memberType === 'R'
                || this.distributorInfo.memberType.toUpperCase() === MemberType.RETAILCUSTOMER) {
                ticket.memberType = MemberType.RETAIL;
            }
            else if (this.distributorInfo.memberType === MemberType.GUEST || this.distributorInfo.memberType === 'G') {
                ticket.memberType = MemberType.GUEST;
            }
            else if (this.distributorInfo.memberType === MemberType.FPC) {
                ticket.memberType = MemberType.FPC;
            }
            else {
                ticket.memberType = MemberType.FOB;
            }
            ticket.userId = this.userInfo.userId;
            ticket.firstName = this.userInfo.firstName;
            ticket.lastName = this.userInfo.lastName;
            ticket.sourceIdentifierValue = createTicketValues.sourceIdentifierValue;
            ticket.statusId = createTicketValues.status;
            this.enableLocationType ? ticket.locationTypeId = createTicketValues.locationType : '';
            ticket.orderId = createTicketValues.orderId ? createTicketValues.orderId : '';
            ticket = this.mapCopyToUsers(ticket);
            this.saveTicket(ticket);
        } else if (!this.validWebOrderNumber && this.ticketCreateForm.controls['orderId'].value.length > 0) {
            this.invalidForm();
        }
    }
    /**
     * invalid Form
     */
    invalidForm(): void {
        this.disableCreate = true;
        this.inValidOrderNumber = true;
        this.ticketCreateForm.controls['orderId'].setValidators([]);
    }

    /**
     * @description This method used to map copyTo users in ticket model
     * @date 2019-11-19
     * @memberof CreateWorkTicket
    */
    mapCopyToUsers(ticket: CreateTicketRequest): CreateTicketRequest {
        ticket.copyToUsers = [];
        if (this.ticketCreateForm.value.copyTo && this.ticketCreateForm.value.copyTo.length) {
            this.ticketCreateForm.value.copyTo.forEach(item => {
                const user: CopyToUser = {
                    userId: item.userId,
                    username: item.username,
                    firstName: item.firstName,
                    lastName: item.lastName
                };
                ticket.copyToUsers.push(user);
            });
        }
        return ticket;
    }


    workTicketTransformDate(date: any) {
        const dateMomentObj = Utils.convertToSpecificDateFormat(date, DateConstants.DateFormat);
        if (dateMomentObj) {
            if (this.ticketCreateForm.controls['dueDate'].valid) {
                this.ticketCreateForm.controls['dueDate'].setValue(moment(dateMomentObj, 'DD-MMM-YYYY'));
            }
        } else {
            this.ticketCreateForm.controls["dueDate"].setValue('');
        }
    }

    saveTicket(saveTicket: any) {
        this._customerservice.saveTicket(saveTicket).subscribe(response => {
            if (response) {
                this.isSubmitted = false;
                this.ticketResponse = response;
                this.messageService.setAuditLogUpdated(true);
                this.disableCreate = false;
                if (this.uploader.queue.length > 0) {
                    this.uploadFile();
                } else {
                    let addedNotification: any = this._translatePipe.get("Ticket " + this.ticketResponse.ticketNumber + " has been Created successfully");
                    this._commonService.createNotification("", addedNotification.value, NotificationType.SUCCESS);
                    this.closeTab();
                }
            }
        });
    }
    closeTab() {
        let tabinfo = new TicketTabInfo();
        tabinfo.distributorID = this.distributorInfo.distributorId;
        tabinfo.tabIndex = this.tabIndex;
        tabinfo.ticketID = this.ticketResponse.id;
        tabinfo.ticketNumber = this.ticketResponse.ticketNumber;
        this.messageService.setClosingTabInfo(tabinfo);
    }

    /** *  UPLOAD FILE   ----- BEGIN ----- ************************* */
    /**
     * Upload file
     */
    uploadFile() {
        if (this.uploader && this.uploader.queue.length > 0) {
            this.ngProgress.start();
            let filelength = 0;
            let ticketNumber = this.ticketResponse.id;
            this.uploader.onBuildItemForm = (item: any, form: any) => {
                filelength++;
                item.withCredentials = false;
                item.uploader.authToken = this._customerservice.getAuthorizationToken();
                const fileNameArr = item.file.name.split('.');
                item.file.name = fileNameArr[0] + '_' + ticketNumber + '_' + filelength
                    + (fileNameArr.length > 1 ? '.' + fileNameArr[fileNameArr.length - 1] : '');
                form.append('fileName', decodeURIComponent(encodeURIComponent(item.file.name)));
                form.append('path', 'content/customer-service/' + this.operatingCountryId + '/');
            };
            for (let i = 0; i < this.uploader.queue.length; i++) {
                this.uploader.queue[i].upload();
            }
        }
    }
    /*Check for max of 5 attachments */
    checkMaxAttachments() {
        if (this.uploader.queue) {
            this.attachmentsLength = this.uploader.queue.length;
            if (this.attachmentsLength >= 5) {
                while (this.attachmentsLength > 5) {
                    this.uploader.queue[this.uploader.queue.length - 1].remove();
                    this.attachmentsLength--;
                }
            }
        }
    }
    /**
     *Empty Method
     */
    noAction() {
    }
    /* clear form*/
    clearTicketForm() {
        this.clearFormAlert.viewActionButtons = true;
        this.clearFormAlert.toggle = true;
        this.clearFormAlert.message = CommonMessage.clearFormData;
    }
    /* on source change*/
    onChangeOfSource(): void {
        if (this.ticketCreateForm.controls['source'].value === this.sourceTypesEnum.Email || this.ticketCreateForm.controls['source'].value === this.sourceTypesEnum.Online_Form) {
            this.phoneNumberFormat = '';
            this.ticketCreateForm.controls['sourceIdentifierValue']
                .setValue(this.distributorInfo ? this.distributorInfo.email : '', { emitModelToViewChange: false });
            this.ticketCreateForm.controls['sourceIdentifierValue'].setValidators([Validators.required, Utils.emailValidationRule]);
        } else {
            this.phoneNumberFormat = this.countryPhoneFormat;
            this.ticketCreateForm.controls['sourceIdentifierValue']
                .setValue(this.distributorInfo ? this.distributorInfo.contactNumber : '');
            this.ticketCreateForm.controls['sourceIdentifierValue'].setValidators([Validators.required, Utils.PhoneNumValidationRule]);
        }
        this.ticketCreateForm.controls['sourceIdentifierValue'].updateValueAndValidity();
    }
    assignToChange() {
        this.ticketCreateForm.controls['dueDate'].setValue('');
        if (this.ticketCreateForm.controls['assignTo'].value) {
            this.showDatePicker = true;
            this.ticketCreateForm.controls['dueDate'].enable();
            this.ticketCreateForm.controls['dueDate'].setValidators([Utils.validateDate]);
        } else {
            this.showDatePicker = false;
            this.ticketCreateForm.controls['dueDate'].disable();
            this.ticketCreateForm.controls['dueDate'].setValidators([]);
        }
        this.ticketCreateForm.controls['dueDate'].updateValueAndValidity();
    }
    /**
     * Gets fbo / retail oder information from titan
     */
    getRecentOrderInformation() {
        if (this.ticketCreateForm.controls['orderId'].valid && this.ticketCreateForm.controls['orderId'].value) {
            this.disableCreate = true;
            this.validWebOrderNumber = false;
            this.inValidOrderNumber = false;
            let webOrderId = this.ticketCreateForm.controls['orderId'].value;
            webOrderId = webOrderId.toUpperCase();
            webOrderId = webOrderId.trim();
            if (webOrderId && webOrderId.length > 0) {
                this._orderservice.getRecentOrderInformation(webOrderId, this.IsoCodeThree).subscribe(response => {
                    if (response) {
                        if (webOrderId !== response.webOrderId) {
                            this.getOrderDetails(webOrderId);
                        } else {
                            this.validWebOrderNumber = true;
                            this.disableCreate = false;
                            this.inValidOrderNumber = false;
                            let addedNotification: any = this._translatePipe.get("Web Order Number validated");
                            this._commonService.createNotification("", addedNotification.value, NotificationType.SUCCESS);
                        }
                    }else{
                        this.orderNotFound();
                    }
                }, error => {
                    this.getOrderDetails(webOrderId);
                });
            }
        }
    }

    /**
     * get order details to validate web order id from AS400
     */
    getOrderDetails(webOrderId: string) {
        this._customerservice.getOrderInfoUsingWebOrderNum(webOrderId, this.IsoCodeThree).subscribe(response => {
            if (response) {
                if (webOrderId !== response.webOrderNumber && webOrderId !== response.orderNumber) {
                    this.orderNotFound();
                    return;
                }
                this.validWebOrderNumber = true;
                this.disableCreate = false;
                this.inValidOrderNumber = false;
                let addedNotification: any = this._translatePipe.get("Web Order Number validated");
                this._commonService.createNotification("", addedNotification.value, NotificationType.SUCCESS);
            }else{
                this.orderNotFound();
            }
        }, error => {
            this.disableCreate = false;
            this.orderNotFound();
        });
    }
    /**
    * notification if order not found 
    */
    orderNotFound() {
        this.disableCreate = true;
        this.inValidOrderNumber = true;
        let addedNotification: any = this._translatePipe.get("Order not found");
        this._commonService.createNotification("", addedNotification.value, NotificationType.ERROR);

    }

    /**
     * @description This method used to get users by search text
     * @date 2019-11-19
     * @memberof CreateWorkTicket
    */
    requestAutocompleteItems = (searchText: string): Observable<any> => {
        const userSearchList: CopyToUserResponse[] = [];
        const url = ApiUrlConstants.enrollmentApigwUrl + 'csp-agents/search?keyword=' + searchText + '&batchSize=10&pageNumber=1';
        const positionTimeout = 0;
        return this._http
            .get(url)
            .map(res => {
                const response: CopyToSearchResponse = res.json();
                if (response && response.content && response.content.length) {
                    response.content.forEach(item => {
                        const user = {
                            value: item.firstName + ' ' + item.lastName + ' ' + item.username,
                            display: item.firstName + ' ' + item.lastName + ' ' + item.username,
                            displayName: item.firstName + ' ' + item.lastName,
                            firstName: item.firstName,
                            lastName: item.lastName, userId: item.userId, username: item.username
                        };
                        userSearchList.push(user);
                    });
                }
                this.setOffsetPosition(positionTimeout);
                return userSearchList;
            });
    }

    /**
   * @description This method used to get users by search text
   * @date 2019-11-19
   * @memberof CreateWorkTicket
  */
    setOffsetPosition(positionTimeout: any): void {
        clearTimeout(positionTimeout);
        positionTimeout = setTimeout(() => {
            const tagInput: any = document.querySelector('.copy_to__block .ng2-tag-input__text-input');
            const dropdownElement: any = document.querySelector('.copy_to__block .ng2-dropdown-menu');
            if (tagInput) {
                dropdownElement.style.left = (12 + tagInput.offsetLeft) + 'px';
            }
        }, 0);
    }
    /**
    * @description getting countries under operating country
    * @date 2020-03-06
    * @param {string} countryCode
    * @memberof CreateWorkTicket
   */
    getAllCountries(countryCode: string): void {
        this._customerservice.getCountriesByOperatingCountry(countryCode).subscribe(response => {
            if (response && response.countriesUnderOperatingCountry.length) {
                this.allCountries = response.countriesUnderOperatingCountry.filter(country => country.countryCode === country.companyCode);
                const selectedCountry = this.allCountries.find(country => country.countryCode === countryCode);
                if (selectedCountry) {
                    this.IsoCodeThree = selectedCountry.companyCode;
                }
            }
        });
    }
    /**
     * @description injecting isocodethree of the selected country
     * @date 2020-03-06
     * @param {string} countryCode
     * @memberof CreateDisputeTicket
     */
    getCountryIsoCodeThree(countryCode: string, isCountryChange?: Boolean) {
        if (this.allCountries) {
            this.IsoCodeThree = this.allCountries.find((country: any) => country.countryCode === countryCode).companyCode;
        }
        if (this.ticketCreateForm.controls['orderId'] && this.ticketCreateForm.controls['orderId'].value && isCountryChange) {
            this.getRecentOrderInformation();
        }
    }

    /**
    * To get focus for orderId field
    */

    onFocusOrderId(): void {
        this.inValidOrderNumber = false;
        if (this.ticketCreateForm.valid) {
            this.disableCreate = false;
        }

    }

    /**
     * To get validation for enable and disable the create button
    */
    getValidationForCreateBtn() {
        if (this.ticketCreateForm.valid) {
            this.disableCreate = false;
        } else {
            this.disableCreate = true;
        }
        return this.disableCreate ? true : false;
    }
}



// WEBPACK FOOTER //
// ./src/app/customerservice/components/work-ticket-create.component.ts